class Permission {
  VIEWER = 'viewer';
  INSPECTOR = 'inspector';
  ADMIN = 'admin';
  OWNER = 'owner';
}

const PermissionFactory = (permission) => new Permission(permission);

export default PermissionFactory;
